export default {
  dispositivos: [],
  markerSelected: '',
}
